import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "bg-background shadow-inner h-full py-5"
}
const _hoisted_3 = { class: "w-full flex-row flex justify-between pt-2 pb-4 px-10 container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M11 17l-5-5m0 0l5-5m-5 5h12"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
  })
], -1)
const _hoisted_6 = { class: "bg-white shadow lg:container rounded-2xl px-11 py-4 justify-between items-start w-full lg:w-3/4 h-full" }
const _hoisted_7 = { class: "flex flex-row justify-between py-5" }
const _hoisted_8 = { class: "flex flex-row space-x-3" }
const _hoisted_9 = { class: "block text-2xl font-bold" }
const _hoisted_10 = {
  key: 0,
  class: "uppercase bg-gray-100 px-3 py-2 rounded"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "ID", -1)
const _hoisted_12 = { class: "space-y-3 p-3 w-full" }
const _hoisted_13 = { class: "space-y-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold" }, "Department Details", -1)
const _hoisted_15 = { class: "flex flex-row items-center" }
const _hoisted_16 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Department", -1)
const _hoisted_18 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Internal Code", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_21 = { class: "space-y-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold" }, "Stages", -1)
const _hoisted_23 = { class: "hidden sm:flex flex-row justify-around w-full items-center" }
const _hoisted_24 = { class: "space-y-2 justify-items-center grid opacity-40" }
const _hoisted_25 = { class: "block mx-auto my-auto bg-gray-200 text-center p-2 rounded" }
const _hoisted_26 = { class: "text-center text-sm flex justify-start items-center 2xl:text-xs sm:text-xxs" }
const _hoisted_27 = { class: "p-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-300",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_31 = { class: "space-y-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold" }, "Location", -1)
const _hoisted_33 = { class: "flex flex-row items-center justify-between" }
const _hoisted_34 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Country", -1)
const _hoisted_36 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Region, City or Zip Code ", -1)
const _hoisted_38 = { class: "flex flex-row items-center w-full justify-end px-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_40 = { class: "space-y-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold" }, "Job Information", -1)
const _hoisted_42 = { class: "space-y-3 block" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400 block" }, "Description", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_45 = { class: "space-y-3 block" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400 block" }, "Requirements", -1)
const _hoisted_47 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = {
  key: 1,
  class: "text-primary-dark text-base font-extralight block"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_51 = { class: "space-y-3 block" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400 block" }, "Responsibilities", -1)
const _hoisted_53 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = {
  key: 1,
  class: "text-primary-dark text-base font-extralight block"
}
const _hoisted_56 = { class: "job_comment_section" }
const _hoisted_57 = {
  key: 0,
  class: "py-2"
}
const _hoisted_58 = { class: "grid justify-items-end py-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_61 = { class: "space-y-4" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold" }, "Company Industry and Job Function", -1)
const _hoisted_63 = { class: "flex flex-row items-center" }
const _hoisted_64 = { class: "flex flex-row w-full space-x-8 items-center py-3" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Industry", -1)
const _hoisted_66 = { class: "flex flex-row w-full space-x-8 items-center py-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Job Function", -1)
const _hoisted_68 = { class: "job_comment_section" }
const _hoisted_69 = { class: "py-2" }
const _hoisted_70 = { class: "grid justify-items-end py-2" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_73 = { class: "space-y-4" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold" }, "Employment Details ", -1)
const _hoisted_75 = { class: "flex flex-row items-center" }
const _hoisted_76 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Employment Type", -1)
const _hoisted_78 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Experience", -1)
const _hoisted_80 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Education", -1)
const _hoisted_82 = { class: "job_comment_section" }
const _hoisted_83 = { class: "py-2" }
const _hoisted_84 = { class: "grid justify-items-end py-2" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_87 = { class: "space-y-5" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold py-2" }, "Keywords", -1)
const _hoisted_89 = {
  key: 1,
  class: "text-base font-extralight capitalize text-primary-dark"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_91 = { class: "space-y-4" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xl font-bold" }, "Annual Salary", -1)
const _hoisted_93 = { class: "flex flex-row items-center" }
const _hoisted_94 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "From", -1)
const _hoisted_96 = { class: "text-base font-extralight" }
const _hoisted_97 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "To", -1)
const _hoisted_99 = { class: "text-base font-extralight" }
const _hoisted_100 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-extralight text-gray-400" }, "Currency", -1)
const _hoisted_102 = { class: "text-base font-extralight" }
const _hoisted_103 = { class: "job_comment_section" }
const _hoisted_104 = { class: "py-2" }
const _hoisted_105 = { class: "grid justify-items-end py-2" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TimeLine = _resolveComponent("TimeLine")!
  const _component_JobCommentForm = _resolveComponent("JobCommentForm")!
  const _component_Chips = _resolveComponent("Chips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loading, {
            active: _ctx.isLoading,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
            "can-cancel": false,
            loader: "spinner",
            color: "#8908F9",
            width: 128,
            height: 128,
            opacity: 0.5,
            "is-full-page": true
          }, null, 8, ["active", "opacity"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              label: "Back",
              variant: "outlined",
              onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router && _ctx.router?.push('/jobs')))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              label: "Sync with jobs",
              variant: "contained"
            }, {
              startIcon: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data && _ctx.data.title ? _ctx.data.title : "-"), 1),
                (_ctx.data && _ctx.data.workable_id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.data && _ctx.data.workable_id), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Button, {
                label: "View Candidates",
                variant: "outlined"
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight capitalize", _ctx.data && !_ctx.data.department && 'text-primary-dark'])
                    }, _toDisplayString(_ctx.data && _ctx.data.department ? _ctx.data.department : _ctx.labelNoInfo), 3)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight", _ctx.data && !_ctx.data.department_code && 'text-primary-dark'])
                    }, _toDisplayString(_ctx.data && _ctx.data.department_code
                    ? _ctx.data.department_code
                    : _ctx.labelNoInfo), 3)
                  ])
                ])
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data && _ctx.data?.job_stages, (el, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "flex items-center"
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(el.number_candidates), 1),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(el.stage.name), 1)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_27, _hoisted_29, 512), [
                        [_vShow, i !== _ctx.data?.job_stages.length - 1]
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight", _ctx.data && !_ctx.data.country && 'text-primary-dark'])
                    }, _toDisplayString(_ctx.data && _ctx.data.country ? _ctx.data.country : _ctx.labelNoInfo), 3)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-md font-extralight", _ctx.data && !_ctx.data.country && 'text-primary-dark'])
                    }, _toDisplayString(_ctx.data && _ctx.data.location ? _ctx.data.location : _ctx.labelNoInfo), 3)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.data.work_type.replaceAll("_", " ")), 1)
                  ])
                ])
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-base font-extralight block", _ctx.data && _ctx.data.description === '' && 'text-primary-dark'])
                  }, _toDisplayString(_ctx.data && _ctx.data.description !== ""
                  ? _ctx.data.description
                  : "No information"), 3)
                ]),
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  (_ctx.data && _ctx.data.requirements !== '<li></li>')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_47, [
                        _createElementVNode("span", {
                          class: "text-base font-extralight block",
                          innerHTML: _ctx.data.requirements
                        }, null, 8, _hoisted_48)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_49, "No information"))
                ]),
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  (_ctx.data && _ctx.data.responsabilities !== '<li></li>')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_53, [
                        _createElementVNode("span", {
                          class: "text-base font-extralight block",
                          innerHTML: _ctx.data.responsabilities
                        }, null, 8, _hoisted_54)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_55, "No information"))
                ]),
                _createElementVNode("div", _hoisted_56, [
                  (_ctx.infoCommentStore && _ctx.infoCommentStore.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        (_ctx.loadingTimeline)
                          ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                          : (_openBlock(), _createBlock(_component_TimeLine, {
                              key: 1,
                              timeline: _ctx.infoCommentStore
                            }, null, 8, ["timeline"]))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_Button, {
                      label: _ctx.expand.comment_info ? 'Close' : 'Add a comment',
                      variant: "",
                      onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expand.comment_info = !_ctx.expand.comment_info))
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_59
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_JobCommentForm, {
                      section: "job_info",
                      onGetDescriptionComments: _cache[3] || (_cache[3] = ($event: any) => (
                  _ctx.getCommentsBySection('getInfoComments')
                ))
                    })
                  ], 512), [
                    [_vShow, _ctx.expand.comment_info]
                  ])
                ])
              ]),
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight", 
                  _ctx.data && !_ctx.data?.company_industry?.name && 'text-primary-dark'
                ])
                    }, _toDisplayString(_ctx.data && _ctx.data.company_industry && _ctx.data.company_industry.name
                    ? _ctx.data.company_industry.name
                    : _ctx.labelNoInfo), 3)
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight", 
                  _ctx.data && !_ctx.data?.job_function?.name && 'text-primary-dark'
                ])
                    }, _toDisplayString(_ctx.data && _ctx.data.job_function && _ctx.data.job_function.name
                    ? _ctx.data.job_function.name
                    : _ctx.labelNoInfo), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    (_ctx.loadingTimeline)
                      ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_TimeLine, {
                          key: 1,
                          timeline: _ctx.functionCommentStore
                        }, null, 8, ["timeline"]))
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_Button, {
                      label: _ctx.expand.comment_function ? 'Close' : 'Add a comment',
                      variant: "",
                      onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expand.comment_function = !_ctx.expand.comment_function))
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_71
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_JobCommentForm, {
                      section: 'job_function',
                      onGetDescriptionComments: _cache[5] || (_cache[5] = ($event: any) => (
                  _ctx.getCommentsBySection('getFunctionComments')
                ))
                    })
                  ], 512), [
                    [_vShow, _ctx.expand.comment_function]
                  ])
                ])
              ]),
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight capitalize", _ctx.data && !_ctx.data?.employment_type && 'text-primary-dark'])
                    }, _toDisplayString(_ctx.data && _ctx.data?.employment_type
                    ? _ctx.replaceEnum(_ctx.data?.employment_type)
                    : _ctx.labelNoInfo), 3)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight capitalize", _ctx.data && !_ctx.data?.experience && 'text-primary-dark'])
                    }, _toDisplayString(_ctx.data && _ctx.data?.experience
                    ? _ctx.replaceEnum(_ctx.data?.experience)
                    : _ctx.labelNoInfo), 3)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _hoisted_81,
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base font-extralight capitalize", _ctx.data && !_ctx.data?.education && 'text-primary-dark'])
                    }, _toDisplayString(_ctx.data && _ctx.data?.education
                    ? _ctx.replaceEnum(_ctx.data?.education)
                    : _ctx.labelNoInfo), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    (_ctx.loadingTimeline)
                      ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_TimeLine, {
                          key: 1,
                          timeline: _ctx.detailsCommentStore
                        }, null, 8, ["timeline"]))
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_Button, {
                      label: _ctx.expand.comment_details ? 'Close' : 'Add a comment',
                      variant: "",
                      onOnClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.expand.comment_details = !_ctx.expand.comment_details))
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_85
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_JobCommentForm, {
                      section: 'job_details',
                      onGetDescriptionComments: _cache[7] || (_cache[7] = ($event: any) => (
                  _ctx.getCommentsBySection('getDetailsComments')
                ))
                    })
                  ], 512), [
                    [_vShow, _ctx.expand.comment_details]
                  ])
                ])
              ]),
              _hoisted_86,
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                (_ctx.data && _ctx.data.keywords?.length > 0)
                  ? (_openBlock(), _createBlock(_component_Chips, {
                      key: 0,
                      chips: _ctx.data.keywords,
                      isInput: false
                    }, null, 8, ["chips"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(_ctx.labelNoInfo), 1))
              ]),
              _hoisted_90,
              _createElementVNode("div", _hoisted_91, [
                _hoisted_92,
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _hoisted_95,
                    _createElementVNode("span", _hoisted_96, _toDisplayString(`$${
                    _ctx.data && _ctx.data.salary_min
                      ? _ctx.numberWithCommas(parseInt(_ctx.data.salary_min, 10))
                      : "0"
                  }`), 1)
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _hoisted_98,
                    _createElementVNode("span", _hoisted_99, _toDisplayString(`$${
                    _ctx.data && _ctx.data.salary_max
                      ? _ctx.numberWithCommas(parseInt(_ctx.data.salary_max, 10))
                      : "0"
                  }`), 1)
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _createElementVNode("span", _hoisted_102, _toDisplayString(`${_ctx.data && _ctx.data.currency_salary ? _ctx.data.currency_salary : "-"}`), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    (_ctx.loadingTimeline)
                      ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_TimeLine, {
                          key: 1,
                          timeline: _ctx.salaryCommentStore
                        }, null, 8, ["timeline"]))
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createVNode(_component_Button, {
                      label: _ctx.expand.comment_salary ? 'Close' : 'Add a comment',
                      variant: "",
                      onOnClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.expand.comment_salary = !_ctx.expand.comment_salary))
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_106
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_JobCommentForm, {
                      section: 'job_salary',
                      onGetDescriptionComments: _cache[9] || (_cache[9] = ($event: any) => (
                  _ctx.getCommentsBySection('getSalaryComments')
                ))
                    })
                  ], 512), [
                    [_vShow, _ctx.expand.comment_salary]
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}